// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class DialogResultsStuct {
    constructor() {
        this.Button = DialogResultsStuct.CallBackInitiator.notSet;
        this.Data = null;
    }
}
DialogResultsStuct.CallBackInitiator = {
    notSet: -1,
    okClick: 0,
    cancelClick: 1,
    closeClick: 2
};
